import { VIEW_MEDIA_URL } from "src/redux/api/appConst";
import { OldMediaItem } from "./types/oldMedia";
import { motion } from 'framer-motion';
import { Video } from "lucide-react";
import { Badge } from "src/components/ui/Badge";

const STATUS_STYLES = {
  PENDING: "bg-amber-100  text-amber-600",
  APPROVED: "bg-emerald-100 text-emerald-600",
  REJECTED: "bg-red-100    text-red-500",
};

const OldMediaCard = ({
  item,
  onView,
}: {
  item: OldMediaItem;
  onView: () => void;
}) => {
  const renderThumbnail = (type: "image" | "video" | "document") => {
    if (type === "image") {
      return (
        <img
          src={`${VIEW_MEDIA_URL}/${item.key}`}
          alt={item.type}
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
      );
    }

    if (type === "video") {
      return (
        <>
          <video
            src={`${VIEW_MEDIA_URL}/${item.key}`}
            muted
            playsInline
            preload="metadata"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 flex items-center justify-center bg-black/10 group-hover:bg-black/20 transition-colors">
            <div className="bg-white/90 rounded-full p-2 shadow-sm">
              <Video className="size-5 text-gray-700" />
            </div>
          </div>
        </>
      );
    }

    if (type === "document") {
      return (
        <svg
          className="w-4 h-4 text-rose-300 opacity-0 group-hover:opacity-100 transition-opacity"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
          />
        </svg>
      );
    }
  };

  return (
    <motion.div
      layout
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.95 }}
      className="group w-30 lg:w-35 xl:50 bg-white border border-gray-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-all"
    >
      {/* Thumbnail */}
      <button
        onClick={onView}
        className="relative w-full aspect-square flex flex-col items-center justify-center overflow-hidden transition-colors"
      >
        {item.type === "document" && (
          <span className="text-[10px] font-black uppercase tracking-widest text-rose-300 mt-1">
            Document
          </span>
        )}
        {renderThumbnail(item.type)}
      </button>

      {/* Info */}
      <div className="p-3 space-y-2">
        <Badge className={`text-xs ${STATUS_STYLES[item.status]}`}>
          {item.status}
        </Badge>

        <div>
          <p className="text-xs text-gray-700 truncate">{item.place}</p>
          <p className="text-xs text-muted-foreground truncate mt-0.5 text-wrap">
            {item.work}
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default OldMediaCard;
